import React from "react";
import dayjs from "dayjs";
import { Row, Col, Form, Card, DatePicker, TimePicker } from "antd";
import "./styles.css";
import { TEST_RIDE } from "../../../Common/Constants";

const TimeRangeForm = ({ formRef, disableRange, disableRangeType }) => {
  const DatePickerChange = (value) => {
    const updateValue = {};

    if (!formRef.current?.getFieldValue("startDate")) {
      updateValue["startDate"] = dayjs(value);
    }

    if (!formRef.current?.getFieldValue("startTime")) {
      updateValue["startTime"] = dayjs(value).set("hour", 0).set("minute", 0);
    }

    if (!formRef.current?.getFieldValue("endDate")) {
      updateValue["endDate"] = dayjs(value);
    }

    if (!formRef.current?.getFieldValue("endTime")) {
      updateValue["endTime"] = dayjs(value).set("hour", 6).set("minute", 0);
    }
    formRef.current?.setFieldsValue(updateValue);
  };

  const disabledToDate = (current) => {
    const fromDate = dayjs(formRef?.current?.getFieldValue("startDate"));
    const fromTime = dayjs(formRef?.current?.getFieldValue("startTime"));
    const newStartDateTime = fromDate
      .set("hour", fromTime.hour())
      .set("minute", fromTime.minute())
      .set("second", 0);
    return (
      current &&
      current.valueOf() >
        dayjs(newStartDateTime).add(disableRange, disableRangeType)
    );
  };

  return (
    <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={6} className="mb1">
      <Card bordered={false} className="input-box">
        <Row gutter={16}>
          <Col xs={14} sm={15} md={8} lg={15}>
            <Form.Item
              name="startDate"
              label={TEST_RIDE.FORM.REQUIRED_FIELDS.START_TIME}
              rules={[
                {
                  required: true,
                  message: TEST_RIDE.FORM.REQUIRED_FIELDS.BLANK_ERROR,
                  validator: (_, value) => {
                    if (
                      !value ||
                      !formRef.current?.getFieldValue("startTime")
                    ) {
                      return Promise.reject();
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <DatePicker
                allowClear={false}
                onChange={DatePickerChange}
                minDate={dayjs().subtract(1, "month")}
                maxDate={dayjs()}
                name="startDate"
                format="YYYY-MM-DD"
                size="large"
                placeholder="Start Date"
                popupClassName="ev-date-picker"
              />
            </Form.Item>
          </Col>
          <Col xs={10} sm={9} md={4} lg={9}>
            <Form.Item label=" " name="startTime" className="mb0">
              <TimePicker
                format="HH:mm"
                size="large"
                placeholder="00:00"
                needConfirm={false}
                showNow={false}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xs={14} sm={15} md={8} lg={15}>
            <Form.Item
              className="mb0"
              name="endDate"
              label={TEST_RIDE.FORM.REQUIRED_FIELDS.END_TIME}
              rules={[
                {
                  required: true,
                  message: TEST_RIDE.FORM.REQUIRED_FIELDS.BLANK_ERROR,
                  validator: (_, value) => {
                    if (!value || !formRef.current?.getFieldValue("endTime")) {
                      return Promise.reject();
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <DatePicker
                allowClear={false}
                onChange={DatePickerChange}
                disabledDate={disabledToDate}
                size="large"
                format="YYYY-MM-DD"
                placeholder="End Date"
                popupClassName="ev-date-picker"
              />
            </Form.Item>
          </Col>
          <Col xs={10} sm={9} md={4} lg={9}>
            <Form.Item label=" " name="endTime" className="mb0">
              <TimePicker
                format="HH:mm"
                size="large"
                placeholder="00:00"
                needConfirm={false}
                showNow={false}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default TimeRangeForm;
